import { TicketTimeLimitOverrideListItem } from '../../../integrated-client/models/';

interface ITableData {
  records: Array<TicketTimeLimitOverrideListItem>;
  totalItems?: number;
}

export class TableData implements ITableData {
  records: Array<TicketTimeLimitOverrideListItem>;
  totalItems?: number;

  constructor() {
    this.records = [];
  }
}
